import * as React from "react";
import { Path } from "react-native-svg";
import { Icon, IIconProps } from "native-base";

const ChevronDown = (props: IIconProps) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <Path
      d="M17.5303 9.53033C17.8232 9.23744 17.8232 8.76256 17.5303 8.46967C17.2374 8.17678 16.7626 8.17678 16.4697 8.46967L17.5303 9.53033ZM12 14L11.4697 14.5303C11.7626 14.8232 12.2374 14.8232 12.5303 14.5303L12 14ZM7.53033 8.46967C7.23744 8.17678 6.76256 8.17678 6.46967 8.46967C6.17678 8.76256 6.17678 9.23744 6.46967 9.53033L7.53033 8.46967ZM16.4697 8.46967L11.4697 13.4697L12.5303 14.5303L17.5303 9.53033L16.4697 8.46967ZM12.5303 13.4697L7.53033 8.46967L6.46967 9.53033L11.4697 14.5303L12.5303 13.4697Z"
      fill="currentColor"
    />
  </Icon>
);

export default ChevronDown;
